module.exports = __webpack_public_path__ + "static/img/bg57.0795d7ac.png";